import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function EmptyState({ icon, title, message, action }) {
  return (
    <Box sx={{
      textAlign: 'center',
      py: 6,
      px: 3,
      color: 'text.secondary',
    }}>
      {icon && <Box sx={{ fontSize: 48, mb: 1, opacity: 0.6 }}>{icon}</Box>}
      <Typography variant="h6" sx={{ color: 'text.primary', mb: 0.5 }}>{title}</Typography>
      {message && <Typography variant="body2" sx={{ mb: 2 }}>{message}</Typography>}
      {action}
    </Box>
  );
}
